import { useIntl } from 'react-intl';
import TooltipComponent from '../../TooltipComponent';

interface IIsPrivateProps {
  data: boolean;
  datacyIndex: number;
}
function IsPrivate(props: IIsPrivateProps): JSX.Element {
  const { formatMessage: f } = useIntl();

  return (
    <div
      className="align-middle text-center justify-content-center"
      style={{ minWidth: '64px', maxWidth: '64px', flex: 1 }}
      data-cy={`row-${props.datacyIndex + 1}-isPrivate-${props.data ? 'private' : 'public'}`}
    >
      <TooltipComponent
        id="ridebook-isPrivate"
        width="auto"
        overlay={
          <div style={{ color: '#fff' }}>
            {props.data
              ? f({ id: 'enum.alarms.ridePrivacy.private' })
              : f({ id: 'enum.alarms.ridePrivacy.public' })}
          </div>
        }
      >
        <i
          className={`text-gray-lighten fs-4 cmd-icons cmd-icon-ride-mode-${
            props.data ? 'private' : 'work'
          }`}
        />
      </TooltipComponent>
    </div>
  );
}

export default IsPrivate;
